import _ from 'lodash'

import {
    COMPANY_AS_CREDITOR_LOAD_TABLE_DATA,
    COMPANY_AS_CREDITOR_TABLE_CHANGE,
    COMPANY_AS_CREDITOR_LOAD_TABLE_DATA_REQUEST,
    COMPANY_AS_CREDITOR_TABLE_LOADING_TRUE,
    COMPANY_AS_CREDITOR_TABLE_LOADING_FALSE,
    COMPANY_AS_CREDITOR_TABLE_DATA_RECEIVED,
} from './constants'

import config from '../../../../../../../../../config'

export function companyAsCreditorLoadTableData(tableId, tableSelector, entId, module, block, level, customData) {
    return {
        type: COMPANY_AS_CREDITOR_LOAD_TABLE_DATA,
        data: {
            tableId,
            tableSelector,
            entId,
            module,
            block,
            level,
            customData,
        },
    }
}

export function companyAsCreditorTableChange(
    tableId,
    tableSelector,
    entId,
    module,
    block,
    level,
    customData,
    queryParams
) {
    return {
        type: COMPANY_AS_CREDITOR_TABLE_CHANGE,
        data: {
            tableId,
            tableSelector,
            entId,
            module,
            block,
            level,
            customData,
            queryParams,
        },
    }
}

export function companyAsCreditorLoadTableDataRequest(
    tableId,
    tableSelector,
    entId,
    module,
    block,
    level,
    lang,
    token,
    queryParams
) {
    return {
        type: COMPANY_AS_CREDITOR_LOAD_TABLE_DATA_REQUEST(tableId),
        payload: {
            uri: _.get(config, `api.${module}.${block}.tables.${tableSelector}.uri`),
            qs: {
                ...queryParams,
                entId,
                lang,
                token,
                level,
            },
            uriParams: {
                entId,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function companyAsCreditorTableDataReceived(module, id, block, customData) {
    return {
        type: COMPANY_AS_CREDITOR_TABLE_DATA_RECEIVED,
        data: {
            module,
            block,
            id,
            customData,
        },
    }
}

export function companyAsCreditorTableLoadingTrue(module, block, id, customData) {
    return {
        type: COMPANY_AS_CREDITOR_TABLE_LOADING_TRUE,
        data: {
            module,
            block,
            id,
            customData,
        },
    }
}
export function companyAsCreditorTableLoadingFalse(module, block, id, customData) {
    return {
        type: COMPANY_AS_CREDITOR_TABLE_LOADING_FALSE,
        data: {
            module,
            block,
            id,
            customData,
        },
    }
}
